<script lang="ts">
  import type { Snippet } from "svelte";

  const {
    href,
    children,
  }: {
    href: string;
    children: Snippet;
  } = $props();
</script>

<a
  {href}
  class="pointer-events-none absolute z-30 m-1 bg-mono-100 p-1 font-mono text-sm uppercase opacity-0 focus:opacity-100"
>
  {@render children()}
</a>
